import { render, staticRenderFns } from "./LoginCallback.vue?vue&type=template&id=6fab5318&scoped=true&"
import script from "./LoginCallback.vue?vue&type=script&lang=js&"
export * from "./LoginCallback.vue?vue&type=script&lang=js&"
import style0 from "./LoginCallback.vue?vue&type=style&index=0&id=6fab5318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab5318",
  null
  
)

export default component.exports